export default "__VITE_ASSET__Dxb6PMdX__"